export default __webpack_public_path__ + "static/media/zengxiao-lin-fBZsl463vJQ-unsplash.ebed5496.jpg";